import React, {Component} from "react";

class CheckButton extends Component {
    /**
     * Renders the CHECK action button.
     * @param {Object} props - React component props.
     * @param {Function} props.checkReserve - Callback fired when the user clicks CHECK.
     * @return {JSX.Element} Rendered CHECK button.
     */
    render() {
        const { checkReserve } = this.props;

        return (
            <button type="button" className="btn btn-check btn-primary submit" onClick={checkReserve}>CHECK</button>
        )
    }
}

export default CheckButton;